import { connect } from 'react-redux'
import DataSourceDeleteView from './DataSourceDeleteView.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

const DataSourceDeleteContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DataSourceDeleteView)

export default DataSourceDeleteContainer;